// Global variables
let totalPrice, totalSave, upCartDrawer, subtotalContainer, subtotalValue;

const upCartCustomLayout = () => {
  /**
   * Updates the cart price layout inside the shadow DOM.
   */
  const updateCartPriceLayout = () => {
    const interval = setInterval(() => {
      // Assign global variables for elements inside the shadow DOM
      subtotalContainer = upCartDrawer?.shadowRoot?.querySelector('.styles_Footer__cartSubtotalTitle__');
      subtotalValue = upCartDrawer?.shadowRoot?.querySelector('.styles_Footer__cartSubtotalValue__');

      if (subtotalContainer && subtotalValue) {
        clearInterval(interval);

        // Create new price layout elements
        const newPriceLayout = document.createElement('div');
        const totalPriceContainer = document.createElement('s');
        const totalSaveContainer = document.createElement('span');

        // Add classes for external styling
        totalPriceContainer.classList.add('custom-total-price-amount');
        totalSaveContainer.classList.add('custom-total-save-amount');
        newPriceLayout.classList.add('custom-price-layout');

        // Set text values from dataset
        totalPriceContainer.innerText = totalPrice.dataset.customTotalPrice;
        totalSaveContainer.innerText = `-${totalSave.dataset.customTotalSave}`;

        // Inline styles (if external CSS is not applied)
        totalPriceContainer.style.color = '#A3A3A3';

        totalSaveContainer.style.background = '#D90000';
        totalSaveContainer.style.color = '#ffffff';
        totalSaveContainer.style.fontSize = '11px';
        totalSaveContainer.style.padding = '5px 10px';
        totalSaveContainer.style.borderRadius = '99px';

        newPriceLayout.style.display = 'flex';
        newPriceLayout.style.alignItems = 'center';
        newPriceLayout.style.gap = '10px';

        subtotalContainer.style.display = 'flex';
        subtotalContainer.style.justifyContent = 'space-between';
        subtotalContainer.style.fontSize = '16px';
        subtotalContainer.style.fontWeight = '700';

        subtotalValue.style.fontSize = '16px';

        // Append new elements inside the subtotal container
        newPriceLayout.appendChild(totalPriceContainer);
        newPriceLayout.appendChild(subtotalValue); // Keep original subtotal value
        newPriceLayout.appendChild(totalSaveContainer);
        subtotalContainer.appendChild(newPriceLayout);
      }
    }, 300);
  };

  /**
   * Fetches the homepage HTML and updates the cart drawer's dataset values.
   */
  const updateValues = () => {
    fetch('/')
      .then((response) => response.text())
      .then((htmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        // Find the total price and total save values in the parsed HTML
        const totalPriceElement = doc.querySelector('[data-custom-total-price]');
        const totalSaveElement = doc.querySelector('[data-custom-total-save]');

        if (totalPriceElement && totalSaveElement) {
          subtotalContainer.querySelector('.custom-total-price-amount').innerText = totalPriceElement.dataset.customTotalPrice;
          subtotalContainer.querySelector('.custom-total-save-amount').innerText = `-${totalPriceElement.dataset.customTotalSave}`;
        }
      })
      .catch((error) => console.error('Error fetching homepage HTML:', error));
  };

  /**
   * Continuously checks for cart drawer existence and updates layout.
   */
  const observeCartDrawer = () => {
    const interval = setInterval(() => {
      // Assign global variables
      totalPrice = document.querySelector('[data-custom-total-price]');
      totalSave = document.querySelector('[data-custom-total-save]');
      upCartDrawer = document.querySelector('#upCart');

      if (upCartDrawer && totalPrice && totalSave) {
        updateCartPriceLayout();
        clearInterval(interval);
      }
    }, 300);
  };

  /**
   * Intercepts API requests to `/cart.js` or `/change.js` and triggers an update.
   */
  const interceptAPIRequests = () => {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      
      // Check if the requested URL contains `/cart.js` or `/change.js`
      if (args[0].includes('/cart.js') || args[0].includes('/change.js')) {
        updateValues();
      }

      return response;
    };
  };

  // Initialize event listeners
  window.addEventListener('DOMContentLoaded', observeCartDrawer);
  interceptAPIRequests();
};

// Run the function when the script loads
upCartCustomLayout();
